import * as types from './types'

const getters = {
  [types.GET_PRODUCT_TO_EDIT](state) {
    return state[types.PRODUCT_TO_EDIT]
  },
}

export default getters
